import { Text } from '../ExpandableLink/ExpandableLink.style';
import { media } from '../../styles';
import styled from 'styled-components';

type ContentProps = {
  isLast?: boolean;
};

type TitleProps = {
  hasDescription?: boolean;
  isMobile?: boolean;
};

type TextProps = {
  isDescription?: boolean;
};

export const Content = styled.div<ContentProps>`
  border: ${({ theme }) => `1px solid ${theme.typography.color.tertiary}`};
  border-bottom: ${({ theme, isLast }) => (isLast ? `1px solid ${theme.typography.color.tertiary}` : 'none')};
  display: flex;
  flex-direction: column;
  font-size: ${({ theme }) => theme.typography.size.small};
  padding: ${({ theme }) => `${theme.spacing.base.xs} ${theme.spacing.base.sm}`};

  ${media.mobilePortrait} {
    flex-wrap: wrap;
  }
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
  margin-bottom: ${({ theme }) => theme.spacing.base.xxs};
`;

export const RowTitle = styled.div<TitleProps>`
  width: ${({ isMobile }) => (isMobile ? '40%' : '25%')};
  min-width: ${({ isMobile }) => (isMobile ? '40%' : '25%')};
`;

export const TitleText = styled(Text)<TitleProps>`
  font-size: ${({ theme }) => theme.typography.size.small};
  font-weight: bold;
  margin-bottom: ${({ hasDescription, theme }) => (hasDescription ? theme.spacing.base.xxs : theme.spacing.base.xs)};
`;

export const TextSmall = styled(Text)<TextProps>`
  font-size: ${({ theme }) => theme.typography.size.small};
  margin-bottom: ${({ isDescription, theme }) => (isDescription ? theme.spacing.base.xs : theme.spacing.base.xxs)};
  color: ${({ isDescription, theme }) =>
    isDescription ? theme.typography.color.secondary : theme.typography.color.primary};
`;
